import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    dataTable: {
      marginTop: theme.spacing(2)
    },
    threeColumnsLayout: {
      display: 'flex',
      alignItems: 'stretch',
      height: '100%',
      flexWrap: 'wrap-reverse'
    },
    leftColumn: {
      borderRight: '1px solid #e0e0e0',
      flexGrow: 1,
      padding: theme.spacing(2)
    },
    centerColumn: {
      flexGrow: 4,
      padding: theme.spacing(2)
    },
    rightColumn: {
      flexGrow: 1
    },
    resume: {
      '& > *': {
        display: 'table'
      }
    },
    columnTitle: {
      marginBottom: theme.spacing(2)
    },
    ReplicateDates: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    InitReplicateDate: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    EndReplicateDate: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    }
  });
